<template>
    <Teleport to="#app">
        <transition name="fade">
            <div
                v-if="show"
                @click="closeModal()"
                role="dialog"
                ref="modal"
                aria-modal="true"
                aria-labelledby="modal-headline"
                class="modal"
            >
                <div @click.stop class="modal__content">
                    <header class="modal__header">
<!--                        <div class="modal__title">-->
<!--                            <h1>-->
<!--                                {{ title ? title : "Modal" }}-->
<!--                            </h1>-->
<!--                        </div>-->
                        <button @click="closeModal" class="modal__close-button">
                            <img
                                src="@/assets/images/icons/close-black.svg"
                                alt="close"
                            />
                        </button>
                    </header>
                    <div class="modal__body">
                        <slot />
                    </div>
                    <footer class="modal__footer">
                        <slot name="footer" />
                    </footer>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<script>
import Teleport from "vue2-teleport";

export default {
    components: {
        Teleport
    },
    props: ["show", "title"],
    data() {
        return {
            showModal: false,
            screenWidth: window.innerWidth
        };
    },
    computed: {
        shouldShowAlternateContent() {
            return this.screenWidth === 768;
        }
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
        document.documentElement.classList.remove("lock");
    },
    methods: {
        closeModal() {
            this.$emit("close");
            document.documentElement.classList.remove("lock");
        }
    },
    watch: {
        show(value) {
            value
                ? document.documentElement.classList.add("lock")
                : document.documentElement.classList.remove("lock");
        }
        // $route() {
        //     document.documentElement.classList.remove("lock");
        // }
    }
};
</script>

<style lang="scss" scoped>
.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    background-color: rgba(0, 0, 0, 0.6);

    padding: 24px 0 0 0;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;

    @media (min-width: 744.98px) and (min-height: 475.98px) {
        padding: 40px;
        align-items: center;
    }
    &__content {
        position: relative;
        z-index: 10;
        background-color: #fbfbfb;
        border-radius: 5px;
        width: 100vw;
        height: 100%;
        max-width: 100vw;
        max-height: 100%;
        // overflow: clip;
        display: flex;
        flex-direction: column;

        @media (min-width: 744.98px) {
            height: auto;
            width: 100%;
            max-width: 611px;
        }
    }
    &__header {
        position: relative;
        min-height: 48px;
        padding: 0 24px;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (min-width: 744.98px) {
            min-height: 64px;
        }
    }
    &__title {
        text-align: center;
        margin-left: 24px;
        margin-right: 16px;
        overflow: hidden;
        flex-grow: 0;
        flex-shrink: 1;
        flex-basis: auto;

        font-size: 15px;
        font-weight: 700;
        line-height: normal;
        color: #000;

        h1 {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    &__close-button {
        position: absolute;
        top: 24px;
        left: 24px;
        width: 15px;
        height: 15px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    &__body {
        flex: 1 1 auto;
        padding: 24px;
        overflow-y: auto;
        outline: none;
    }

    &__footer {
        padding: 16px 24px;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
